import { render, staticRenderFns } from "./broadcastModel.vue?vue&type=template&id=2eb028d2&scoped=true&"
import script from "./broadcastModel.vue?vue&type=script&lang=js&"
export * from "./broadcastModel.vue?vue&type=script&lang=js&"
import style0 from "./broadcastModel.vue?vue&type=style&index=0&id=2eb028d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb028d2",
  null
  
)

export default component.exports